import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../models/Analytics';
import '../../styles/main.less';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	showRequestInvitePopup?: boolean;
}

// tslint:disable-next-line: no-default-export
export default class AppPrivacy extends React.Component<IProps, IState> {
	public state: IState = {
		showRequestInvitePopup: false,
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Privacy Policy';
		logPageView('Privacy');
	}

	public render() {
		return (
			<MainContainer>
				<div className='privacy-outerContainer'>
					<h1>Levitate App and Outlook/Gmail Add-In Privacy Policy</h1>

					<p>
						<em>This privacy policy was last updated on July 15, 2019</em>
					</p>
					<p>
						This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII)
						is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with
						other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy
						carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in
						accordance with our website.
					</p>

					<h2>What personal information do we collect from the people that visit our website or app?</h2>

					<p>
						When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, company name,
						mailing address, phone number, credit card information or other details to help you with your experience.
					</p>

					<h2>When do we collect information?</h2>

					<p>We collect information from you when you register on our site or enter information on our site.</p>

					<h2>How do we use your information?</h2>

					<p>
						We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey
						or marketing communication, surf the website, or use certain other site features in the following ways:
					</p>

					<ul>
						<li>To personalize your experience</li>
						<li>To quickly process your transactions</li>
					</ul>

					<h2>How do we protect your information?</h2>

					<p>
						Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have
						special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit
						information you supply is encrypted via Secure Socket Layer (SSL) technology.
					</p>

					<p>
						We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information.
					</p>

					<p>
						All transactions are processed through a gateway provider and no credit card information is stored on our servers.
					</p>

					<h2>Google Apps, Office 365 and Hosted Exchange</h2>

					<p>
						When you connect Levitate with your email/calendar system such as Google Apps for Business, Gmail, Office 365, Outlook.com,
						or traditional Microsoft Exchange Server, our system will have access to data in your address book, email messages, and calendar.
						We will use meeting history, metadata about sent email messages (name and email of the email sender, recipient, and time/date when message was sent),
						and your address book to help build your contact list in the Levitate application. Depending on the features included in your Levitate plan,
						we may also use these statistics about meetings and sent email messages to provide you with reporting, notifications, and analytics to help
						you better understand the interactions you or your colleagues have had with individuals and companies.
					</p>
					<p>
						Levitate also requires permission to send email, place items on your calendar, and update your contacts. The permission to send email
						allows you to use the Levitate application to compose email messages to your contacts. The ability to place items on your calendar allows
						us to set reminders to follow up with contacts or to complete action items. The ability to update your contacts allows Levitate to potentially
						add contacts to your email address book that were created in Levitate or to sync information from Levitate back into your email address book.
					</p>
					<p>
						<strong>Our servers do not read or store the content of your email messages</strong> or the details of the meetings on your calendar (such as meeting descriptions and attachments).
					</p>
					<p>
						Levitate <em>does</em> offer optional client-side email add-ins for Microsoft Outlook and Gmail. If you install these add-ins, the add-in may parse
						the content of individual emails in order to allow the add-in to function properly. This content will only be sent to our servers with your active consent,
						such as when you opt to save the content as a note in Levitate or opt to save information from an email signature into a contact's Levitate profile.
					</p>

					<h2>POP and IMAP email systems</h2>

					<p>
						When you connect Levitate with a POP or IMAP email system, our system will have access to data in your email messages.
						We will use metadata about sent email messages (name and email of the email sender, recipient, and time/date when message was sent)
						to help build your contact list in the Levitate application. Depending on the features included in your Levitate plan,
						we may also use statistics about sent email messages to provide you with reporting, notifications, and analytics to help
						you better understand the interactions you or your colleagues have had with individuals and companies.
					</p>
					<p>
						Levitate also requires permission to send email. The permission to send email
						allows you to use the Levitate application to compose email messages to your contacts.
					</p>
					<p>
						<strong>Our servers do not read or store the content of your email messages</strong>.
					</p>
					<p>
						Levitate <em>does</em> offer optional client-side email add-ins for Microsoft Outlook and Gmail. If you install these add-ins, the add-in may parse
						the content of individual emails in order to allow the add-in to function properly. This content will only be sent to our servers with your active consent,
						such as when you opt to save the content as a note in Levitate or opt to save information from an email signature into a contact's Levitate profile.
					</p>

					<h2>Do we use 'cookies'?</h2>

					<p>
						Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser
						(if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information.
						We also use cookies to help us compile data about site traffic and site interaction so that we can offer better site experiences and tools in the future.
					</p>

					<p>
						You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies.
						You do this through your browser settings. Since each browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.
					</p>
					<p>
						If you turn cookies off, some of the features that make your site experience more efficient may not function properly.
					</p>

					<h2>Third-party disclosure</h2>

					<p>
						We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.
						Additionally, data that you enter into the Levitate application (including but not limited to notes, contacts, company names, and action items)
						is not sold, traded, or otherwise transferred to outside parties.
					</p>

					<h2>Third-party links</h2>

					<p>
						Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites
						have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of
						these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.
					</p>

					<h2>California Online Privacy Protection Act</h2>

					<p>
						CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach
						stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites
						collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating
						exactly the information being collected and those individuals or companies with whom it is being shared.
						- See more at:
						<a target='_blank' href='http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf'>
							http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
						</a>
					</p>

					<p>According to CalOPPA, we agree to the following:</p>

					<p>
						Users can visit our site anonymously.Once this privacy policy is created, we will add a link to it on our home page or as a minimum,
						on the first significant page after entering our website. Our Privacy Policy link includes the word 'Privacy' and can easily be found
						on the page specified above.
					</p>

					<p>You will be notified of any Privacy Policy changes:</p>
					<ul>
						<li>On our Privacy Policy Page</li>
					</ul>

					<p>Can change your personal information:</p>
					<ul>
						<li>By emailing us at <a target='_blank' href='mailto:support@levitateapp.com'>support@levitateapp.com</a></li>
					</ul>

					<h2>How does our site handle Do Not Track signals?</h2>

					<p>
						We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.
					</p>

					<h2>Does our site allow third-party behavioral tracking?</h2>
					<p>
						It's also important to note that we do not allow third-party behavioral tracking
					</p>

					<h2>COPPA (Children Online Privacy Protection Act)</h2>

					<p>
						When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy
						Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces
						the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.
					</p>

					<p>We do not specifically market to children under the age of 13 years old.</p>

					<h2>CAN SPAM Act</h2>

					<p>
						The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives
						recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.
					</p>

					<p>
						We collect your email address in order to:
					</p>
					<ul>
						<li>Send information, respond to inquiries, and/or other requests or questions</li>
						<li>Process orders and to send information and updates pertaining to orders.</li>
						<li>Send you additional information related to your product and/or service</li>
						<li>Market to our mailing list or continue to send emails to our clients after the original transaction has occurred.</li>
					</ul>

					<p>
						To be in accordance with CANSPAM, we agree to the following:
					</p>

					<ul>
						<li>Not use false or misleading subjects or email addresses.</li>
						<li>Identify the message as an advertisement in some reasonable way.</li>
						<li>Include the physical address of our business or site headquarters.</li>
						<li>Monitor third-party email marketing services for compliance, if one is used.</li>
						<li>Honor opt-out/unsubscribe requests quickly.</li>
						<li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
					</ul>

					<p>
						If at any time you would like to unsubscribe from receiving future emails, you can follow the instructions at the bottom of each
						email or email us at support@levitateapp.com and we will promptly remove you from ALL correspondence.
					</p>

					<h2>Contacting Us</h2>

					<p>
						If there are any questions regarding this privacy policy, you may contact us using the information below.
					</p>

					<p>
						Real Magic, Inc.<br />
						2409 Crabtree Blvd, Suite 107<br />
						Raleigh, NC 27604<br />
						USA<br />
						<a className='footerLink' href='tel:18882537050'>1-888-253-7050</a><br />
						<a className='footerLink' href='mailto:support@levitateapp.com'>support@levitateapp.com</a>
					</p>

				</div>
			</MainContainer>
		);
	}
}
